import { render, staticRenderFns } from "./EditRedeem.vue?vue&type=template&id=8848ac40"
import script from "./EditRedeem.vue?vue&type=script&lang=js"
export * from "./EditRedeem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports